import React from 'react';

import Button from 'material-ui/Button';
import Drawer from 'material-ui/Drawer';
import Typography from 'material-ui/Typography';
import IconButton from 'material-ui/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Avatar from 'material-ui/Avatar';

import Console from '../../lib/debug';

export default class HDrawer extends React.Component {
    getAvatar() {
        if (this.props.iconUrl) {
            return <Avatar className="icon" src={this.props.iconUrl} />;
        }

        return <Avatar className="icon">{this.props.icon}</Avatar>;
    }

    render() {
        Console.render('HDrawer');
        let drawerActions = null;
        if (this.props.actions) {
            drawerActions = (
                <div className="drawer-actions">
                    <Button onClick={this.props.onClose}>Cancel</Button>
                    <Button
                        onClick={this.props.onSave}
                        color="primary"
                        variant="raised"
                    >
                        Save
                    </Button>
                </div>
            );
        }

        let avatar = this.getAvatar();

        let hasFeedInput = this.props.hasFeedInput;
        let bodyClasses = 'drawer-body';
        if (hasFeedInput) {
            bodyClasses += ' has-feed-input';
        }

        let title = null;
        if (this.props.title && this.props.title.length > 0) {
            title = (
                <Typography
                    classes={{ title: 'drawer-title' }}
                    variant="title"
                    color="inherit"
                >
                    {this.props.title}
                </Typography>
            );
        }

        let subTitle = null;
        if (this.props.subTitle && this.props.subTitle.length > 0) {
            subTitle = (
                <Typography
                    classes={{ subheading: 'drawer-subheading' }}
                    variant="subheading"
                    color="inherit"
                >
                    {this.props.subTitle}
                </Typography>
            );
        }

        let overriddenCaption = null;
        if (
            this.props.overriddenCaption &&
            this.props.overriddenCaption.length
        ) {
            overriddenCaption = (
                <Typography
                    classes={{ caption: 'drawer-caption overridden-caption' }}
                    variant="caption"
                    color="inherit"
                >
                    {this.props.overriddenCaption}
                </Typography>
            );
        }

        let caption = null;
        if (this.props.caption && this.props.caption.length > 0) {
            caption = (
                <Typography
                    classes={{ caption: 'drawer-caption' }}
                    variant="caption"
                    color="inherit"
                >
                    {this.props.caption}
                </Typography>
            );
        }

        return (
            <Drawer
                className="h-drawer"
                anchor="right"
                onClose={this.props.onClose}
                open={this.props.open}
            >
                <div className="drawer-header">
                    <div className="drawer-header-inner">
                        <div>
                            <IconButton
                                color="inherit"
                                aria-label="Menu"
                                className="close-button"
                                onClick={this.props.onClose}
                            >
                                <CloseIcon />
                            </IconButton>
                        </div>
                        <div className="drawer-heading-container">
                            {avatar}
                            <div>
                                {title}
                                {subTitle}
                            </div>
                            {overriddenCaption}
                            {caption}
                        </div>
                    </div>
                    <div className="drawer-description">
                        <Typography color="inherit">
                            {this.props.description}
                        </Typography>
                    </div>
                </div>
                <div className={bodyClasses}>{this.props.children}</div>
                {drawerActions}
            </Drawer>
        );
    }
}



// WEBPACK FOOTER //
// ./src/view/common/HDrawer.jsx